import { Button } from 'antd';
import { styled } from 'styled-components';
export const Container = styled(Button).withConfig({
  displayName: "LoginButtonstyle__Container",
  componentId: "sc-mvig7i-0"
})(["", " background:", ";box-shadow:0 8px 12px 0 rgba(223,43,65,0.2);&:hover{", " background:", " !important;}"], {
  "userSelect": "none",
  "borderRadius": "0.5rem",
  "borderStyle": "none !important",
  "paddingLeft": "0.75rem",
  "paddingRight": "0.75rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "21px",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))",
  "transitionProperty": "all",
  "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
  "transitionDuration": "150ms"
}, ({
  theme
}) => `linear-gradient(90deg, ${theme.colors.primary[50]} 0%, ${theme.colors.primary[40]} 100%)`, {
  "--tw-text-opacity": "1 !important",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1)) !important"
}, ({
  theme
}) => `linear-gradient(90deg, ${theme.colors.primary[50]} 0%, ${theme.colors.primary[40]} 100%)`);